import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_csato from "../../assets/img/3.png";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projCsatoL_penalty.png";

const Laszlo_Csato_penalty = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_csato}
              /* this will be the text on the banner */
              alt="Team strength and success in penalty shootouts"
            />{" "}
            <p className="text7">László Csató</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            <p className="text8">Research Group of Operations Research and Decision Systems, SZTAKI </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Previous empirical studies in sports economics have shown that better football teams are more likely to win a penalty shootout. 
            However, a recent paper has not found such an impact in UEFA club competitions based on Football Club Elo Ratings. The aim of 
            the project is to investigate this issue by using alternative measures of strength such as UEFA club coefficient, as well as 
            the market value of the kickers and the goalkeeper.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                    Brinkschulte, M., Wunderlich, F., Furley, P., & Memmert, D. (2023). The obligation to succeed when it matters the most–The 
                    influence of skill and pressure on the success in football penalty kicks. Psychology of Sport and Exercise, 65, 102369.
                </li>
                <li>
                    Csató, L., & Petróczy, D. G. (2026). Are penalty shootouts better than a coin toss? 
                    Evidence from international club football in Europe. arXiv:2510.17641.
                </li>
                <li>
                    Krumer, A. (2020). Pressure versus ability: Evidence from penalty shoot-outs between teams from different divisions. 
                    Journal of Behavioral and Experimental Economics, 89, 101578.
                </li>
                <li>
                    Wunderlich, F., Berge, F., Memmert, D., & Rein, R. (2020). Almost a lottery: the influence of team strength on 
                    success in penalty shootouts. International Journal of Performance Analysis in Sport, 20(5), 857-869.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Csato_penalty;